import { useCallback, useEffect, useState } from 'react';
import { getUnassignedSummaryService } from '../../../../services/unassignedReturns.service';
import { buildDraftDefaults, formatDateRange } from './unassignedUtils';

// Feeds the main-tab badges and the Unassigned summary cards.
const useUnassignedSummary = (enabled) => {
  const [summary, setSummary] = useState(null);

  const loadSummary = useCallback(async (fromDate, toDate) => {
    try {
      const res = await getUnassignedSummaryService({ fromDate, toDate });
      if (res?.data?.Status === 200 && res.data.Entity) setSummary(res.data.Entity);
    } catch {
      // Badges stay as they were when the summary is unavailable.
    }
  }, []);

  useEffect(() => {
    if (!enabled) return;
    const { fromDate, toDate } = buildDraftDefaults();
    const range = formatDateRange(fromDate, toDate);
    void loadSummary(range.fromDate, range.toDate);
  }, [enabled, loadSummary]);

  return { summary, loadSummary };
};

export default useUnassignedSummary;
